import { ArrowDownUp, ZoomIn, ZoomOut } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sallerProfile } from "../../redux/states/auth/thunk";
import ConfirmDeleteModal from "../../Modals/ConfirmDeleteModal";

export default function Header({ sidebarOpen, setSidebarOpen }) {
  const [profileOpen, setProfileOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { profile, loading, error } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(sallerProfile());
  }, [dispatch]);

  // Fullscreen toggle
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
    setIsFullscreen(!isFullscreen);
  };

  const handleConfirmLogout = () => {
    // Remove localStorage keys
    localStorage.removeItem("adminAuth");
    localStorage.removeItem("persist:root");
    // Optional: redirect to login page
    window.location.href = "/login";
  };

  return (
    <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4 flex justify-between items-center relative">
      {/* Left Section */}
      <div className="flex items-center space-x-4">
        {/* Mobile toggle */}
        <button
          className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg md:hidden transition-colors"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        <div>
          <h1 className="font-bold text-xl text-gray-800">Dashboard</h1>
          <p className="text-sm text-gray-500 hidden sm:block">
            Welcome back, {profile?.name || "Admin"}
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center space-x-4 relative">
        {/* Fullscreen button */}
        <button
          onClick={toggleFullscreen}
          className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors hidden md:flex"
        >
          {isFullscreen ? <ZoomOut /> : <ZoomIn />}
        </button>

        {/* Profile */}
        <div className="relative">
          <button
            onClick={() => setProfileOpen(!profileOpen)}
            className="flex items-center space-x-2 focus:outline-none"
          >
            <div className="text-right hidden sm:block">
              <p className="font-medium text-gray-800">
                {profile?.name || "Admin"}
              </p>
              <p className="text-xs text-gray-500">
                {profile?.role || "Administrator"}
              </p>
            </div>
            <img
              src={profile?.profile_image || "https://i.pravatar.cc/40"}
              alt="admin"
              className="rounded-full w-10 h-10 border-2 border-gray-300 hover:border-blue-500 transition-colors cursor-pointer"
            />
          </button>

          {/* Profile dropdown/modal */}
          {profileOpen && (
            <div className="absolute right-0 mt-2 w-64 bg-white border rounded shadow-lg z-50">
              <div className="p-4 border-b">
                <p className="text-gray-800 font-semibold">
                  {profile?.name || "-"}
                </p>
                <p className="text-gray-500 text-sm">{profile?.role || "-"}</p>
              </div>
              <div className="p-4 space-y-2 text-sm">
                <p>
                  <span className="font-medium">Email:</span>{" "}
                  {profile?.email || "-"}
                </p>
                <p>
                  <span className="font-medium">Mobile:</span>{" "}
                  {profile?.mobile || "-"}
                </p>
                <p>
                  <span className="font-medium">WhatsApp:</span>{" "}
                  {profile?.whatsapp || "-"}
                </p>
                <p>
                  <span className="font-medium">Address:</span>{" "}
                  {profile?.address || "-"}
                </p>
                <p>
                  <span className="font-medium">City:</span>{" "}
                  {profile?.city || "-"}
                </p>
                <p>
                  <span className="font-medium">State:</span>{" "}
                  {profile?.state || "-"}
                </p>
                <p>
                  <span className="font-medium">Country:</span>{" "}
                  {profile?.country || "-"}
                </p>
                <p>
                  <span className="font-medium">Pincode:</span>{" "}
                  {profile?.pincode || "-"}
                </p>
              </div>
              <ul className="border-t">
                <li>
                  <button
                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                    onClick={() => setModalOpen(true)}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
      <ConfirmDeleteModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirmLogout}
        title="Logout"
        message="Do you really want to logout? This action cannot be undone."
      />
    </div>
  );
}
